export function decodeFinkedaReturn(raw) {
  if (!raw) return null;
  try {
    const padded = String(raw).replace(/-/g, "+").replace(/_/g, "/");
    const padLen = (4 - (padded.length % 4)) % 4;
    const parsed = JSON.parse(atob(padded + "=".repeat(padLen)));
    if (!parsed || typeof parsed !== "object") {
      return { status: "UNKNOWN", bucket: "OTHER", message: String(raw) };
    }
    return parsed;
  } catch {
    return { status: "UNKNOWN", bucket: "OTHER", message: String(raw) };
  }
}

export function finkedaResultBucket(status, bucket) {
  if (bucket === "SUCCESS" || bucket === "FAILED" || bucket === "PENDING" || bucket === "OTHER") {
    return bucket;
  }
  const s = String(status || "").trim().toUpperCase();
  if (s === "SUCCESS" || s === "COMPLETED") return "SUCCESS";
  if (["FAILED", "FAILURE", "CANCELLED", "CANCELED"].includes(s)) return "FAILED";
  if (["PENDING", "PROCESSING", "INITIATED", "CREATED", ""].includes(s)) return "PENDING";
  return "OTHER";
}
